
import React from 'react';
import { Link } from 'react-router-dom';

interface ServiceCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  link: string;
}

const ServiceCard = ({ title, description, icon, link }: ServiceCardProps) => {
  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="bg-white p-6 md:p-8 rounded-lg shadow-md border border-gray-100 transition-all hover:shadow-lg focus-within:ring-2 focus-within:ring-brand-blue">
      <div className="mb-4 text-brand-red" aria-hidden="true">{icon}</div>
      <h3 className="text-xl font-semibold mb-3 text-gray-900">{title}</h3>
      <p className="text-gray-600 mb-6">{description}</p>
      <Link 
        to={link} 
        className="text-brand-red font-medium hover:bg-brand-lightBlue hover:px-2 hover:py-1 hover:rounded transition-all inline-flex items-center gap-2 focus:outline-none focus:underline"
        onClick={handleClick}
        aria-label={`Meer informatie over ${title}`}
      >
        Meer informatie
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M5 12h14"></path>
          <path d="m12 5 7 7-7 7"></path>
        </svg>
      </Link>
    </div>
  );
};

export default ServiceCard;
